import React from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientClients } from '../../../../store/crossClient/crossClientResults'
import { selectSafeAuthenticatedUser } from '../../../../store/auth/authSlice'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { Button, ButtonVariant } from '../../../../components/Button/Button'
import { LinkButton } from '../../../../components/Button/LinkButton'
import { CrossClientQueryResultDisplay } from '../../../../models/CrossClient'
import classNames from 'classnames'

export interface CrossClientResultButtonsProps {
  result: CrossClientQueryResultDisplay
  variant?: ButtonVariant
  withText?: boolean
  className?: string
}

export const CrossClientResultButtons: React.FC<CrossClientResultButtonsProps> = ({ result, variant = 'borderless', withText = false, className }) => {
  const clients = useAppSelector(selectCrossClientClients)
  const currentUserId = useAppSelector(selectSafeAuthenticatedUser).id

  const client = clients[result.clientId]

  const disabled = !client || (client.owner?.ownerId && client.owner.ownerId !== currentUserId)

  const buttonClassName = classNames('p-2 cross-client-cta button-small', className)

  if (disabled) {
    return (
      <div className='d-flex gap-2'>
        <Tooltip className='zocks-text-gray-500' placement='top' title='Only the contact owner can email this client.'>
          <Button variant={variant} className={buttonClassName} disabled>
            <i className='bi bi-envelope fs-6' />
            {withText ? 'Send message' : null}
          </Button>
        </Tooltip>
        <Tooltip className='zocks-text-gray-500' placement='top' title='Only the contact owner can view client details.'>
          <Button variant={variant} className={buttonClassName} disabled>
            <i className='bi bi-arrow-up-right fs-6' />
            {withText ? 'Open profile' : null}
          </Button>
        </Tooltip>
      </div>
    )
  }

  return (
    <div className='d-flex gap-2'>
      <LinkButton variant={variant} className={buttonClassName} to={`/email/new?contactId=${result.clientId}`} target='_blank'>
        <i className='bi bi-envelope fs-6' />
        {withText ? 'Send message' : null}
      </LinkButton>
      <LinkButton variant={variant} className={buttonClassName} to={`/library/manage-contacts/contacts/${result.clientId}`} target='_blank'>
        <i className='bi bi-arrow-up-right fs-6' />
        {withText ? 'Open profile' : null}
      </LinkButton>
    </div>
  )
}
